import { deepClone, merge } from "../array.utils";
import { getApp } from "../experience.utils";
let enabled = true;
export const getEnabled = () => {
    return enabled;
};
let platformName;
export const getPlatformName = () => {
    return platformName;
};
export const setPlatformName = (name) => {
    platformName = name;
};
let configStore;
export const getConfigStore = () => {
    if (!configStore) {
        configStore = new Map();
    }
    return configStore;
};
export let initialized = false;
export const getInitialized = () => initialized;
export const setInitialized = (value) => {
    initialized = value;
};
/**
 * Adds a configuration object to the config store.
 *
 * @param key - The key under which the configuration will be stored.
 * @param config - The configuration object to be added. The 'key' property will be removed from this object before storing.
 * @returns void
 */
export const addConfig = (key, config) => {
    if (!configStore)
        getConfigStore();
    let cloneConfig = deepClone(config);
    delete cloneConfig["key"];
    configStore.set(key, cloneConfig);
};
/**
 * Checks if the configuration store contains a specific key.
 *
 * @param key - The key to check in the configuration store.
 * @returns A boolean indicating if the key exists in the configuration store, or undefined if the store is not initialized.
 */
export const hasConfig = (key) => {
    if (!configStore)
        getConfigStore();
    return configStore.has(key);
};
/**
 * Retrieves a configuration object from the config store based on the provided key.
 *
 * @param key - The key used to identify the configuration object.
 * @returns A record containing the configuration data, or undefined if the key does not exist.
 */
export const getConfig = (key) => {
    if (!configStore)
        getConfigStore();
    return configStore.get(key);
};
/**
 * Deletes a configuration object from the config store by key.
 *
 * @param key - The key of the configuration to be deleted.
 * @returns void
 */
export const deleteConfig = (key) => {
    if (!configStore)
        getConfigStore();
    if (configStore.has(key)) {
        configStore.delete(key);
    }
    else {
        console.warn(`Configuration with key "${key}" does not exist.`);
    }
};
/**
 * Updates the configuration with the provided payload.
 *
 * This function deep clones the payload, removes the 'action' property,
 * and then merges it with the existing configuration if it exists.
 * If the configuration does not exist, it adds the new configuration.
 *
 * @param payload - The payload containing the configuration data.
 *
 * @remarks
 * - The 'action' property is removed from the payload before processing.
 * - The configuration is identified by a key, which is either provided in the payload or obtained from `getApp()`.
 * - If a configuration with the given key already exists, it is merged with the new configuration.
 * - If no configuration with the given key exists, the new configuration is added.
 */
export const updateConfig = (payload) => {
    const config = deepClone(payload);
    delete config["action"];
    const key = config.key || getPlatformName() || getApp();
    if (hasConfig(key)) {
        addConfig(key, merge(getConfig(key), config));
    }
    else {
        addConfig(key, config);
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/@celine/passive-tracking/dist/config/config-store.js
// module id = ./node_modules/@celine/passive-tracking/dist/config/config-store.js
// module chunks = 0